import { CommonModule } from '@angular/common';
import { LoadingSymbolModule } from 'NewAngular/features/components/loaders/loading-symbol/loading-symbol.module';
import { ModalBaseModule } from 'NewAngular/features/components/modals/modal-base/modal-base.module';
import { ImageModule } from 'NewAngular/features/directives/image/image.module';
import * as i0 from "@angular/core";
export class RedtailCredentialsModalModule {
}
RedtailCredentialsModalModule.ɵfac = function RedtailCredentialsModalModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RedtailCredentialsModalModule)(); };
RedtailCredentialsModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: RedtailCredentialsModalModule });
RedtailCredentialsModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, ImageModule, LoadingSymbolModule, ModalBaseModule] });
